// store/invites/invitesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ActivePlayer {
	id: number;
	username: string;
	level: number;
	svarka_experience: number;
	svarka_minimal_experience: number;
	svarka_maximal_experience: number;
	chips: number;
	avatarLink: string;
}

interface InvitesState {
	activePlayers: ActivePlayer[];
	loading: boolean;
	error: string | null;
}

const initialState: InvitesState = {
	activePlayers: [],
	loading: false,
	error: null,
};

const invitesSlice = createSlice({
	name: 'invites',
	initialState,
	reducers: {
		setActivePlayers: (state, action: PayloadAction<ActivePlayer[]>) => {
			state.activePlayers = action.payload;
			state.loading = false;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setError: (state, action: PayloadAction<string | null>) => {
			state.error = action.payload;
			state.loading = false;
		},
		clearActivePlayers: state => {
			state.activePlayers = [];
		},
	},
});

export const { setActivePlayers, setLoading, setError, clearActivePlayers } = invitesSlice.actions;
export default invitesSlice.reducer;
